module.exports = __webpack_public_path__ + "media/images/ui__textCrossLight--dark-77e04963b20b38442a05a1924edb5d9d.png";